import * as React from "react";
import styled from "styled-components";
import { Button } from "../Button";
import { onUpdatedQuery, PaginationProps } from "../Paginator";
import { mediaQueries, style } from "../style";

type Props = {
  error: TableErrorProps;
};

export type TableErrorProps = {
  message?: string;
  buttonLabel?: string;
  pagination?: PaginationProps;
  onClick?: () => any;
  fetchMore?: ({
    variables,
    updateQuery,
  }: {
    variables: {
      pagination: {
        per_page: number;
        page: number;
      };
    };
    updateQuery: (prevPageResult: any, { fetchMoreResult }: any) => any;
  }) => any;
};

const ErrorEl = styled.div`
  text-align: center;
  padding: ${style.vars.space["4"]};
  width: 100%;
`;

const ErrorMessage = styled.p`
  display: inline;
  margin-right: ${style.vars.space["3"]};

  ${mediaQueries.mediumMax} {
    display: block;
    margin-bottom: ${style.vars.space["2"]};
  }
`;

export const TableError: React.FC<Props> = ({ error }) => {
  const { message = "Something went wrong.", buttonLabel = "Refresh", onClick, fetchMore, pagination } = error;

  return (
    <ErrorEl>
      <ErrorMessage>{message}</ErrorMessage>
      {(onClick || fetchMore) && (
        <Button
          compact
          onClick={() => {
            if (fetchMore) {
              fetchMore({
                variables: {
                  pagination: {
                    page: pagination?.page ?? 0,
                    per_page: pagination?.per_page ?? 0,
                  },
                },
                updateQuery: onUpdatedQuery,
              });
            } else {
              onClick?.();
            }
          }}
        >
          {buttonLabel}
        </Button>
      )}
    </ErrorEl>
  );
};
